module.exports = __webpack_public_path__ + "static/img/120.6397a5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/120.png
// module id = 33Ww
// module chunks = 0